import { render, staticRenderFns } from "./Tradle.vue?vue&type=template&id=767500c2&scoped=true&"
import script from "./Tradle.vue?vue&type=script&lang=js&"
export * from "./Tradle.vue?vue&type=script&lang=js&"
import style0 from "./Tradle.vue?vue&type=style&index=0&id=767500c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767500c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VContent,VIcon,VSnackbar})
